<template>
  <el-dialog 
    top="10vh"
    :visible.sync="dialogVisible" 
    width="80vw"
    height="500px"
    :close-on-click-modal='false' 
    :fullscreen="false"
    v-loading="isLoading"
    append-to-body
  >
      <template #title>
        <span>模型选择</span>
      </template>
      <template #default>
        <div class="main-content" :style="{ backgroundImage: 'url(' + contHearerBg + ')' }">
              <div class="contentHeader">
                  <div>
                    <div class="slected-title">已选模型：</div>
                    <div class="select-model-content">
                      <div class="select-model" v-for="(item,index) in selectedModels" :key="index">
                        <div class="ellipsis" :title="item.text">
                          {{item.text}}
                        </div>
                        <div>
                          <i class="el-icon-close" @click="handleDelete(index)"></i>
                        </div>
                      </div>
                  </div>
                  </div>
                  <div class="">
                      <!-- <el-input type="text" value="" placeholder="请输入关键字..."> -->
                    <el-input
                      placeholder="请输入关键字..."
                      suffix-icon="el-icon-search"
                      v-model="searchModel"
                      @change="handleSearch">
                    </el-input>
                  </div>

                  <el-row class="hotsearch">
                      <el-col class="title" :span="2">
                          <div>推荐</div>
                          <div>模型</div>
                      </el-col>
                      <el-col class="keys" :span="22">
                          <div>
                              <el-link v-for="(item, index) in recModels" :key="index" @click="btnHotpageTo(item)">{{ item.text
                              }}</el-link>
                          </div>
                      </el-col>
                  </el-row>
                  <el-row class="hotsearch">
                      <el-col class="title" :span="2">
                          <div>历史</div>
                          <div>模型</div>
                      </el-col>
                      <el-col class="keys" :span="22">
                          <div>
                              <el-link v-for="(item, index) in modelHistoryList" :key="index" @click="btnHistoryPageTo(item)">{{
                                  item.text
                              }}</el-link>
                          </div>
                      </el-col>
                  </el-row>
              </div>
          </div>
      </template>
      <template #footer>
        <div class="footer-center">
          <el-button type="primary" plain @click="selectOk">确定</el-button>
          <el-button type="info" plain @click="dialogVisible=false">取消</el-button>
        </div>
      </template>
  </el-dialog>
</template>
  
<script>
import contHearerBg from "@/assets/img/bigScreen/bg1.jpg";
import userDocApi from "@/assets/js/userDocApi";
export default {
  name: "dialogSelectModel",
  components: {},
  props: {},
  data() {
    return {
      contHearerBg: contHearerBg,
      dialogVisible: false,
      isLoading: false,
      selectedModels:[],
      params:{},
      allModels:[],
      recModels:[],
      modelHistoryList:[],
      searchModel:""
    };
  },
  computed: {},
  methods: {
    getData() {
      this.isLoading = true;

      this.modelHistoryList = JSON.parse( localStorage.getItem( 'modelsHistory' ) ) || [];

      let path = this.params?.path || 'usys/factory/factor/model/release';
      let params = {
        "skip": 0,
        "limit": 999,
        "tags": this.params?.tags || ['tech_sbom']
      }
      this.allModels.push(
        { id : '07', type:'content', withCatalog : false,  initPbc : 'DA000044', initPbcType : 'cmd',  infoPbc : 'DA000044', infoPbcType : 'cmd', params:{}, tags  : [], text : '小智智聚', enabled:true  }
      );
      userDocApi.getPublicList(path, params, _res => {
        if(_res.code == 200 && _res?.data?.records){
          const values = _res.data.records?.map(file=>{
            let _tags     = Object.keys( file.tags );
            let _nameTag  = _tags.find( _t => _t.startsWith( 'name_' ) );
            let _pbcTag   = _tags.find( _t => _t.startsWith( 'bizCode_' ) );
            return {
              fid: file.fid,
              id          : file.fid,
              type        : 'content',
              withCatalog : false,
              initPbc     : _pbcTag.slice( 'bizCode_'.length ),
              initPbcType : 'cmd',
              infoPbc     : '',
              infoPbcType : '',
              tags: _tags,
              params      : {},
              text        : _nameTag.slice( 'name_'.length ),
              enabled     : true
            };
          });
          this.allModels.push(...values);
          this.handleSearch();
        }
        this.isLoading = false;
      });
    },
    handleSearch( val ){
      let _key  = val?.trim() || "";
      this.recModels  = [];
      if( _key?.length > 0 ){
        this.recModels  = this.allModels.filter( _m => _m.text.includes( _key ) ).slice( 0, 9 );
      }else{
        this.recModels  = this.allModels.slice( 0, 9 );
      }
    },
    selectOk(){
      //设置历史模型
      let deleteHis = [...this.modelHistoryList];
      this.selectedModels.forEach(item => {
        const index = deleteHis.findIndex(hindex => hindex.id == item.id);
        if(index > -1) deleteHis.splice(index, 1);
      });
      let hisList = [...this.selectedModels, ...deleteHis];
      localStorage.setItem( 'modelsHistory', JSON.stringify(hisList.slice( 0, 9 )) );

      //通知父组件
      this.$emit('selectValue', this.selectedModels);
      this.dialogVisible = false;
    },
    //推荐模型点击事件
    btnHotpageTo(item){
      let model = this.selectedModels.filter(_item => {
        return _item.id === item.id;
      })
      if(model.length == 0) this.selectedModels.push(item);
    },
    //历史模型点击事件
    btnHistoryPageTo(item){
      let model = this.selectedModels.filter(_item => {
        return _item.id === item.id;
      })
      if(model.length == 0) this.selectedModels.push(item);
    },
    //删除已选择的内容
    handleDelete( index ){
      this.selectedModels.splice(index, 1);
    }
  },
  created() {
    this.$EventBus.$on("opendialogSelectModel", (e) => {
        this.params = e.params;
        if(e?.selectedModels && Array.isArray(e?.selectedModels)){
          this.selectedModels = [...e.selectedModels];
        }
        
        this.dialogVisible = true;
        this.getData();
    })
  },
  mounted(){
    
  }
};
</script>
<style lang="less" scoped>
@import "~@/assets/skin/var.less";


.title-center {
  text-align: center;
  font-size: 18px;
}
.main-content {
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    flex-direction: column;
    flex: 1;
    // padding-top: 10px;
    height: 100%;
    // background-position: 50%;
    background-size: cover;
    position: relative;

    .contentHeader {
        // background-color: #eeeef4;
        padding: 10px;
        width: 90%;
        margin: 0 auto;
        // text-align: center;

        .hotsearch {
            width: 100%;
            height: 56px;
            margin-top: 32px;
            text-align: left;
            font-size: 0;
            color: @workbench-background-color;
            overflow: hidden;

            .title {
                display: inline-block;
                height: 56px;
                border-radius: 4px;
                overflow: hidden;
                padding-top: 5px;
                text-align: center;
                font-size: 16px;
                letter-spacing: 4px;
                text-indent: 4px;
                line-height: 22px;
                background: @cmew-hotsearch-title-background;
            }

            .keys {
                padding-left: 20px;
                display: inline-block;
                height: 56px;
                vertical-align: top;
                text-align: left;

                .el-link {
                    color: #font-color[light];
                    display: inline-block;
                    vertical-align: top;
                    margin-right: 24px;
                    margin-bottom: 10px;
                    font-size: #font-size[normal];
                    line-height: 22px;

                    &:hover {
                        color: @workbench-background-color !important;
                    }
                }
            }
        }

      .slected-title {
        color: #fff;
      }
      .select-model-content {
        display: flex;
        flex-wrap: wrap;
        margin-top:5px;
        height: 70px;
        overflow-y: auto;
        margin-bottom: 5px;
      }
      
      .select-model {
        max-width: 200px;
        display: flex;
        margin-right: 10px;
        margin-bottom:5px;
        border: solid 1px rgba( 255,255,255,.3);
        padding: 3px 10px;
        color:#ffffff;
        height: 30px;
        i {
          cursor: pointer;
        }
      }


    }
    .cursearch {
        width: 100%;
    }

    .ellipsis {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        margin-right: 5px;
      }

}
.footer-center {
    text-align: center;
      button {
        padding: 12px 30px;
      }
  }
</style>
  